/**
 * ProtocolCard Component
 * ======================
 * Individual protocol card with premium styling
 * - SVG icons
 * - Hover glow effects
 * - Connection dot
 */

import React, { forwardRef, useState } from 'react';

const ProtocolCard = forwardRef(({ number, title, description, iconPath, position }, ref) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      ref={ref}
      className={`protocol-card ${position} ${isHovered ? 'hovered' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Card glow effect */}
      <div className="card-glow"></div>
      
      {/* Connection dot */}
      <div className="card-connector">
        <div className="connector-dot"></div>
        <div className="connector-ring"></div>
      </div>

      {/* Card content */}
      <div className="card-content">
        {/* Icon */}
        <div className="card-icon">
          <svg 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1.5"
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d={iconPath} />
          </svg>
        </div>

        {/* Text */}
        <div className="card-text">
          <p className="card-description">{description}</p>
          <h3 className="card-title">{title}</h3>
        </div>

        {/* Bottom line */}
        <div className="card-line"></div>
      </div>
    </div>
  );
});

ProtocolCard.displayName = 'ProtocolCard';

export default ProtocolCard;
